// extracted by mini-css-extract-plugin
export default {"rightActions":"JemAhxFd78kP4DFFBf4z","footerSection":"m2rMKIDFL1on0fg8lWfT","titleSection":"U0WbFLyVEwQanz1LHpxT","subTitle":"n_gV8oRiGBl8zn3uTwDH"};